import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'

import Theme from 'core/themes/model'
import Info from 'core/components/validatedForm/Info'
import ExternalLink from 'core/components/ExternalLink'
import { VOLUME_BACKED_VM_STRING } from './selectors'
import { attachVolumeDoc } from 'app/docLinks'

interface VmSnapshotInfoProps {
  vm: { imageName?: string; volumeIds?: string[] }
  isClonedVM?: boolean
}

export default function VmSnapshotInfo({ vm, isClonedVM = false }: VmSnapshotInfoProps) {
  const classes = useStyles()
  const usesEphemeralStorage = vm?.imageName !== VOLUME_BACKED_VM_STRING
  const hasVolumes = !!vm?.volumeIds?.length

  return (
    <>
      {usesEphemeralStorage ? (
        <Info className={clsx(classes.box, !hasVolumes && classes.warning)} error>
          This VM uses an ephemeral root disk
          {hasVolumes && ' and has volumes attached'}.{' '}
          {isClonedVM
            ? 'The cloned VM will be created from snapshot image of type'
            : 'The resulting snapshot will be an image of type'}{' '}
          “VM Ephemeral Disk Snapshot” and will ONLY include the ephemeral disk. Any attached
          volumes will NOT be included in the snapshot
          {isClonedVM && ' or attached to cloned VM'}. Read{' '}
          <ExternalLink url={attachVolumeDoc}>this article</ExternalLink> for more information.
        </Info>
      ) : (
        <Info className={clsx(classes.box, classes.warning)} error>
          This VM uses a volume for root disk{hasVolumes && ' and has volumes attached'}.{' '}
          {isClonedVM
            ? 'The cloned VM will be created from snapshot image of type'
            : 'The resulting snapshot will be of an image type'}{' '}
          “VM Volume Snapshot”. The operation will create a volume snapshot of the VM root disk
          volume
          {hasVolumes && ' as well as the additional attached volumes,'} and will store that
          information in the VM snapshot file.
        </Info>
      )}
    </>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  box: {
    marginBottom: theme.spacing(2),
  },
  warning: {
    border: `1px solid ${theme.palette.yellow[500]}`,
    background: theme.palette.yellow[100],
  },
}))
